import React, { FC } from 'react'
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import LinearProgress, {
  LinearProgressProps,
} from '@mui/material/LinearProgress'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import prettyBytes from 'pretty-bytes'

const useStyles = makeStyles(theme => createStyles({
  root: {
    marginTop: theme.spacing(1),
  },
  rightAlign: {
    textAlign: 'right',
  },
}))

interface UploadFileProgressBarProps {
  color: LinearProgressProps["color"],
  filename: string,
  size: number,
  uploadedBytes: number,
  percentDone: number,
  remainingTime: number,
}

const UploadFileProgressBar: FC<React.PropsWithChildren<UploadFileProgressBarProps>> = ({
  color,
  filename,
  size,
  uploadedBytes,
  percentDone,
  remainingTime,
}) => {
  const classes = useStyles()

  const timeLeftSeconds = Math.round(remainingTime / 1000) + 1
  const timeLeftMinutes = Math.floor(timeLeftSeconds / 60)
  const timeLeftMinutesSeconds = timeLeftSeconds % 60

  const timeLeft = timeLeftSeconds < 60 ?
    `${timeLeftSeconds} secs` :
    `${timeLeftMinutes} mins ${timeLeftMinutesSeconds} secs`

  return (
    <Grid container className={ classes.root }>
      <Grid item xs={ 12 }>
        <Typography variant="body2">
          { filename } - { prettyBytes(size) }
        </Typography>
      </Grid>
      <Grid item xs={ 12 }>
        <LinearProgress 
          variant="determinate"
          value={ percentDone }
          color={ color }
        />
      </Grid>
      <Grid item xs={ 6 }>
        <Typography variant="caption">
          { `${ prettyBytes(uploadedBytes) } - ${ percentDone }%` }
        </Typography>
      </Grid>
      {
        remainingTime > 0 && (
          <Grid item xs={ 6 } className={ classes.rightAlign }>
            <Typography variant="caption">
              { timeLeft } remaining
            </Typography>
          </Grid>
        )
      }
    </Grid>
  )
}


export default UploadFileProgressBar